// Header.jsx
import React from "react";
import talentTalksLogo from "../assets/Talenttalklogo.png";

const Header = ({
  handleRun,
  handleSubmit,
  runDisabled = false,
  timeRemaining = 0,
  timeUp = false,
}) => {
  // Format time as HH:MM:SS
  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  // Determine if warning should be shown
  const isBlinking = timeRemaining <= 120 && timeRemaining > 0;
  const isUrgent = timeRemaining <= 60 && timeRemaining > 0;

  const timerClass = `
  px-6 py-2 text-sm font-bold rounded-full
  flex items-center justify-center gap-2
  shadow-md border border-white/30
  ${
    timeUp
      ? "bg-red-700 text-white"
      : isUrgent
        ? "bg-red-600 text-white animate-pulse"
        : isBlinking
          ? "bg-yellow-400 text-black animate-pulse"
          : "bg-gradient-to-r from-[#8F5BF0] via-[#6A2BE0] to-[#4B1498] text-white"
  }
`;
  return (
    <header className="h-14 flex items-center justify-between px-4 border-b border-[#E6E0F3] bg-white/90 dark:bg-slate-900 text-textPrimaryLight dark:text-textPrimaryDark text-xs">
      {/* Left: CodeLab */}
      <img src={talentTalksLogo} alt="TalentTalks" className="h-9 w-auto object-contain select-none" />
      {/* Center: Timer Bar */}
      {/* Center: Timer Bar */}
      {(timeRemaining > 0 || timeUp) && (
        <div className={`flex-1 mx-4 ${timerClass}`}>
          {timeUp ? (
            <span className="text-sm font-semibold">⏱ Time’s up!</span>
          ) : isUrgent ? (
            <span className="text-sm font-semibold animate-pulse">
              Submit your code! Only{" "}
              <span className="font-mono font-extrabold ml-1">
                {formatTime(timeRemaining)}
              </span>{" "}
              Time left!
            </span>
          ) : (
            <span className="text-sm font-medium">
              Time remaining{" "}
              <span className="font-mono font-extrabold ml-1">
                {formatTime(timeRemaining)}
              </span>
            </span>
          )}
        </div>
      )}
      {/* Right: Buttons */}
      <div className="flex items-center gap-3">
        <button
          onClick={handleRun}
          disabled={runDisabled}
          className={`px-3 py-1 text-xs font-semibold rounded
               ${runDisabled ? "bg-[#D9C8F4] text-white cursor-not-allowed" : "bg-[#4B1498] text-white hover:bg-[#3B0F7A]"} focus:outline-none focus:ring-2 focus:ring-[#A66FFF]`}
        >
          ▶ Run
        </button>

        <button
          onClick={handleSubmit}
          className="px-3 py-1 text-xs font-semibold rounded bg-[#4B1498] text-white hover:bg-[#3B0F7A] focus:outline-none focus:ring-2 focus:ring-[#A66FFF]"
        >
          ⤓ Submit
        </button>
      </div>
    </header>
  );
};

export default Header;
